/**
 * @file Constructeur de definition de cible avec valeurs par defaut (partage par targets.ts et hubDecor.ts).
 */
import type { TargetDef } from './types';

/** Constructeur de cible avec valeurs par defaut raisonnables (arbre tirable, destructible). */
export const def = (d: Partial<TargetDef> & Pick<TargetDef, 'id' | 'name' | 'visual'>): TargetDef => ({
  family: 'tree',
  legacyType: 'Tree',
  hpMult: 1,
  rewardMult: 1,
  drops: [],
  rarity: { tier: 'common', weight: 100 },
  biomes: [],
  shootable: true,
  harvestable: false,
  destructible: true,
  colliderRadius: 0.9,
  solid: false,
  ...d,
});
